import { useState } from 'react';
import { StoreProductDetail} from '../../../../../model/leads/leads';

interface UseRecommendProductsOptions {
  /**
   * Optional callback when products are saved
   */
  onSave?: (selectedProducts: StoreProductDetail[]) => void;
}

/**
 * Hook to manage the product recommendation functionality
 * @param options Configuration options
 * @returns Functions and state for product recommendation
 */
export const useRecommendProducts = (options: UseRecommendProductsOptions) => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [selectedProducts, setSelectedProducts] = useState<StoreProductDetail[]>([]);

  const openRecommendDialog = () => {
    setIsDialogOpen(true);
  };

  const closeRecommendDialog = () => {
    setIsDialogOpen(false);
  };

  const handleProductsSelected = (products: StoreProductDetail[]) => {
    setSelectedProducts(products);
    if (options.onSave) {
      options.onSave(products);
    }
    closeRecommendDialog();
  };

  return {
    isDialogOpen,
    selectedProducts,
    openRecommendDialog,
    closeRecommendDialog,
    handleProductsSelected
  };
};